export var SCREEN = 'Screen';
export var DRAWER = 'Drawer';
export var MODAL = 'Modal';
export var INLINE_DIALOG = 'InlineDialog';
export var DROPDOWN = 'Dropdown';
export var UI_EVENT_TYPE = 'UI';
export var TRACK_EVENT_TYPE = 'TRACK';
export var SCREEN_EVENT_TYPE = 'SCREEN';
export var OPERATIONAL_EVENT_TYPE = 'OPERATIONAL';
export var ANALYTICS_BRIDGE_CHANNEL = 'analyticsBridge';